// removed by extract-text-webpack-plugin
module.exports = {"default":"default___369J7","flex":"flex___9VLju","icon":"icon___ETYN2","label":"label___2H2ZL","opened":"opened___3Hmr8","primary":"primary___2J8WV","brand":"brand___1rtlP","terciary":"terciary___2hp2X","correct":"correct___3n1hq","wrong":"wrong___9i44w","featured":"featured___1_Xjh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/RoundButton/index.scss
// module id = 77
// module chunks = 0